/* BOHDY slide-out cart (sections/cart-drawer.liquid).
 *
 * - Any Add to cart form (action /cart/add) that another script has not
 *   already cancelled is sent to /cart/add.js instead of leaving the page. The
 *   pastry box builder validates and fills its line-item properties in its own
 *   submit handler first; when it cancels (box not full, no day), nothing is
 *   added here either.
 * - Quantity / remove go to /cart/change.js by line key, which keeps the
 *   line's properties (pastry picks, pickup or delivery date).
 * - Each request asks for this section's HTML in the same response (Section
 *   Rendering API), so the drawer is re-rendered by the Liquid, never by JS.
 * - Without JavaScript the cart icon links to /cart and forms post normally.
 */
(function () {
  'use strict';
  // The theme editor re-inserts the section (and this script) on every edit.
  if (window.BohdyCartDrawer) return;

  var lastFocus = null;

  function drawer() { return document.querySelector('[data-cart-drawer]'); }
  function enabled() { var d = drawer(); return d && !d.hasAttribute('data-disabled'); }
  function onCartPage() { var d = drawer(); return d && d.getAttribute('data-page-type') === 'cart'; }

  function focusables(root) {
    return Array.prototype.filter.call(
      root.querySelectorAll('a[href], button:not([disabled]), select:not([disabled]), input:not([type="hidden"]):not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function open() {
    var d = drawer();
    if (!d || d.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    d.removeAttribute('inert');
    d.classList.add('is-open');
    document.documentElement.classList.add('bohdy-cd-lock');
    setExpanded(true);
    var close = d.querySelector('.bohdy-cd__close');
    window.setTimeout(function () { (close || d.querySelector('.bohdy-cd__panel')).focus({ preventScroll: true }); }, 30);
  }

  function close() {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    cancelHeldCheckout(); // closing means the customer changed their mind
    d.classList.remove('is-open');
    d.setAttribute('inert', '');
    document.documentElement.classList.remove('bohdy-cd-lock');
    setExpanded(false);
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  function setExpanded(isOpen) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-open]'), function (el) {
      el.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function setCount(count) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-open]'), function (el) {
      el.setAttribute('aria-label', 'Cart (' + count + ')');
    });
  }

  function showError(message) {
    var d = drawer();
    var box = d && d.querySelector('[data-cd-error]');
    if (!box) return;
    box.textContent = message || 'Something went wrong. Please try again.';
    box.hidden = false;
  }

  function announce(text) {
    var d = drawer();
    var status = d && d.querySelector('[data-cd-status]');
    if (!status || !text) return;
    status.textContent = '';
    window.setTimeout(function () { status.textContent = text; }, 60);
  }

  // Line keys contain ':' etc., so match them by attribute value, not CSS.
  function findLine(root, key) {
    return Array.prototype.filter.call(root.querySelectorAll('[data-cd-line]'), function (el) {
      return el.getAttribute('data-key') === key;
    })[0] || null;
  }

  // Where keyboard focus was inside the drawer, described so it survives the
  // re-render (the old elements are replaced).
  function focusSpot(d) {
    var el = document.activeElement;
    if (!el || !d.contains(el)) return null;
    var line = el.closest('[data-cd-line]');
    var offer = el.closest('[data-cd-offer]');
    return {
      key: line ? line.getAttribute('data-key') : null,
      step: el.getAttribute('data-cd-step'),
      offer: offer ? offer.getAttribute('data-cd-offer') : null,
      select: el.tagName === 'SELECT',
      checkout: el.getAttribute('name') === 'checkout'
    };
  }

  // Back to the same control (line key + action), else the line's nearest
  // control, else the same suggestion's control, else Close (line removed).
  function restoreFocus(d, spot) {
    var target = null;
    if (spot.key) {
      var line = findLine(d, spot.key);
      if (line) {
        target = (spot.step && line.querySelector('[data-cd-step="' + spot.step + '"]')) ||
          line.querySelector('[data-cd-step]');
      }
    } else if (spot.offer) {
      var offer = d.querySelector('[data-cd-offer="' + spot.offer + '"]');
      if (offer) target = offer.querySelector(spot.select ? 'select' : '.bohdy-cd__offer-btn');
    } else if (spot.checkout) {
      target = d.querySelector('[data-cd-checkout] [name="checkout"]');
    }
    target = target || d.querySelector('.bohdy-cd__close');
    if (target) target.focus({ preventScroll: true });
  }

  // Swap in the drawer content from a Section Rendering response.
  function render(sections) {
    var d = drawer();
    if (!d || !sections) return;
    var html = sections[d.getAttribute('data-section-id')];
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cd-content]');
    var current = d.querySelector('[data-cd-content]');
    if (!fresh || !current) return;
    var spot = d.classList.contains('is-open') ? focusSpot(d) : null;
    current.replaceWith(fresh);
    setCount(parseInt(fresh.getAttribute('data-item-count'), 10) || 0);
    if (spot) restoreFocus(d, spot);
  }

  function busy(on) {
    var d = drawer();
    if (d) d.classList.toggle('is-busy', on);
  }

  function request(url, options) {
    options.headers = Object.assign({ Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, options.headers || {});
    return fetch(url, options).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (body) {
        if (!res.ok) {
          var err = new Error(body.description || body.message || 'Cart error');
          err.body = body;
          throw err;
        }
        return body;
      });
    });
  }

  function sectionId() { return drawer().getAttribute('data-section-id'); }

  // Every cart request runs one at a time, in click order, and each one
  // renders before the next starts. So a slow response can never paint over
  // a newer cart, and a queued step reads the quantity the previous step
  // left (see change()).
  var queue = Promise.resolve();
  var pending = 0;
  function enqueue(task) {
    pending += 1;
    busy(true);
    var run = queue.then(task).catch(function () {}).then(function () {
      pending -= 1;
      if (!pending) busy(false);
    });
    queue = run;
    return run;
  }

  // Resolves once every queued request (including ones queued while waiting)
  // has finished and rendered.
  function whenIdle() {
    var current = queue;
    return current.then(function () { return current === queue ? null : whenIdle(); });
  }

  // Checkout is a native POST to /cart. While cart updates are still queued
  // it waits for them, then submits the freshly rendered form, so Shopify's
  // checkout never starts from a cart that is still changing. A held checkout
  // is a ticket: closing the drawer (or pressing Checkout again) cancels it,
  // and it only proceeds if it is still the current ticket and the drawer is
  // still open.
  var heldCheckout = null;

  function cancelHeldCheckout() {
    var ticket = heldCheckout;
    heldCheckout = null;
    if (ticket && ticket.button && document.contains(ticket.button)) {
      ticket.button.removeAttribute('aria-busy');
      ticket.button.disabled = false;
    }
  }

  function checkoutAfterQueue(submitter) {
    cancelHeldCheckout();
    var ticket = { button: submitter || null };
    heldCheckout = ticket;
    if (submitter) { submitter.setAttribute('aria-busy', 'true'); submitter.disabled = true; }
    whenIdle().then(function () {
      if (heldCheckout !== ticket) return; // cancelled (drawer closed) or replaced
      heldCheckout = null;
      var d = drawer();
      if (!d || !d.classList.contains('is-open')) return;
      var form = d.querySelector('[data-cd-checkout]');
      if (!form) return; // the cart emptied; the drawer shows the empty state
      var button = form.querySelector('[name="checkout"]');
      if (form.requestSubmit) {
        form.requestSubmit(button);
      } else {
        var flag = document.createElement('input');
        flag.type = 'hidden';
        flag.name = 'checkout';
        form.appendChild(flag);
        form.submit();
      }
    });
  }

  function refreshNow() {
    var d = drawer();
    if (!d) return Promise.resolve();
    var url = d.getAttribute('data-root-url') + '?sections=' + encodeURIComponent(sectionId());
    return request(url, { method: 'GET' }).then(render).catch(function () {});
  }

  function refresh() { return enqueue(refreshNow); }

  function add(form, submitter) {
    // Read the form now: the pastry builder filled its properties in its own
    // submit handler, and the customer may change the form while we wait.
    var data = new FormData(form);
    data.append('sections', sectionId());
    data.append('sections_url', window.location.pathname);
    if (submitter) { submitter.setAttribute('aria-busy', 'true'); submitter.disabled = true; }
    return enqueue(function () {
      var d = drawer();
      return request(d.getAttribute('data-cart-add-url') + '.js', { method: 'POST', body: data })
        .then(function (body) {
          render(body.sections);
          open();
          announce(d.getAttribute('data-added-text'));
        })
        .catch(function (err) {
          // Shopify's message, e.g. sold out or not enough stock.
          return refreshNow().then(function () { open(); showError(err.message); });
        });
    }).then(function () {
      if (submitter && document.contains(submitter)) { submitter.removeAttribute('aria-busy'); submitter.disabled = false; }
    });
  }

  // step: +1 / -1, or 'remove'. The target quantity is worked out when the
  // request runs, from the line as last rendered, so two quick + taps make
  // two steps instead of sending the same number twice.
  function change(key, step) {
    return enqueue(function () {
      var d = drawer();
      var line = findLine(d, key);
      if (!line) return null; // already removed by an earlier step
      var current = parseInt(line.getAttribute('data-qty'), 10) || 0;
      var quantity = step === 'remove' ? 0 : Math.max(0, current + step);
      if (quantity === current) return null;
      var titleEl = line.querySelector('.bohdy-cd__item-title');
      var title = titleEl ? titleEl.textContent.trim() : '';
      return request(d.getAttribute('data-cart-change-url') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: [sectionId()], sections_url: window.location.pathname })
      })
        .then(function (body) {
          render(body.sections);
          // The new line markup is not a live region; say what changed.
          var after = findLine(drawer(), key);
          announce(after ? title + ', quantity ' + after.getAttribute('data-qty') : 'Removed ' + title);
        })
        .catch(function (err) { return refreshNow().then(function () { showError(err.message); }); });
    });
  }

  document.addEventListener('submit', function (event) {
    if (event.defaultPrevented || !enabled()) return;
    var form = event.target;
    if (form.hasAttribute('data-cd-checkout')) {
      if (!pending) return; // nothing in flight: normal checkout
      event.preventDefault();
      checkoutAfterQueue(event.submitter);
      return;
    }
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add(\.js)?(\?|$)/.test(action) || form.hasAttribute('data-no-drawer')) return;
    event.preventDefault();
    add(form, event.submitter);
  });

  document.addEventListener('click', function (event) {
    if (!enabled()) return;
    var opener = event.target.closest('[data-cart-open]');
    if (opener && !onCartPage()) {
      event.preventDefault();
      open();
      return;
    }
    var d = drawer();
    if (!d || !d.contains(event.target)) return;
    if (event.target.closest('[data-cd-close]')) { close(); return; }
    var stepper = event.target.closest('[data-cd-step]');
    if (stepper) {
      var step = stepper.getAttribute('data-cd-step');
      change(stepper.getAttribute('data-key'), step === 'remove' ? 'remove' : parseInt(step, 10) || 0);
    }
  });

  document.addEventListener('keydown', function (event) {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    if (event.key === 'Escape') { close(); return; }
    if (event.key !== 'Tab') return;
    var items = focusables(d.querySelector('.bohdy-cd__panel'));
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  // Back/forward cache can show a stale cart; re-render on return.
  window.addEventListener('pageshow', function (event) { if (event.persisted && enabled()) refresh(); });

  // Theme editor: open the drawer while its section or a block is selected.
  document.addEventListener('shopify:section:select', function (event) {
    var d = drawer();
    if (d && event.detail.sectionId === d.getAttribute('data-section-id')) open();
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    var d = drawer();
    if (d && event.detail.sectionId === d.getAttribute('data-section-id')) close();
  });

  setExpanded(false);
  window.BohdyCartDrawer = { open: open, close: close, refresh: refresh };
})();
